/*!
  Brava, by Koding Themes
  recomendations.js
  https://kodingthemes.com
*/

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    initDynamicRecommendations(document);
  });

  document.addEventListener('shopify:section:load', (e) => {
    initDynamicRecommendations(e.target);
  });

  function initDynamicRecommendations(root) {
    const scope = root || document;
    const recommendedSections = scope.querySelectorAll('.dynamic-recommendation-section');
    recommendedSections.forEach((recommendedSection) => {
      void loadRecommendationSection(recommendedSection);
    });
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
  }

  async function loadRecommendationSection(recommendedSection) {
    const productRecommendationBody = recommendedSection.querySelector('.grid-container-wrapper');
    if (!productRecommendationBody) return;

    const url = (recommendedSection.dataset.url || '').trim();
    if (!url) {
      recommendedSection.classList.add('d-none');
      return;
    }

    if (recommendedSection.dataset.recommendationsLoading === 'true') return;

    if (recommendedSection._recommendationsAbortController) {
      recommendedSection._recommendationsAbortController.abort();
    }
    const abortController = new AbortController();
    recommendedSection._recommendationsAbortController = abortController;

    recommendedSection.dataset.recommendationsLoading = 'true';
    productRecommendationBody.innerHTML = '';

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: abortController.signal,
      });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const data = await response.json();
      const products = Array.isArray(data && data.products) ? data.products : [];

      if (products.length === 0) {
        recommendedSection.classList.add('d-none');
        return;
      }

      if (products.length < 3) productRecommendationBody.classList.add('w-100');
      else productRecommendationBody.classList.remove('w-100');

      const htmlChunks = await Promise.all(
        products.map(async (product) => {
          const handle = product && product.handle;
          if (!handle) return '';

          const productUrl = `/products/${encodeURIComponent(handle)}?view=recommended-product`;
          const productResponse = await fetch(productUrl, {
            credentials: 'same-origin',
            signal: abortController.signal,
          });
          if (!productResponse.ok) return '';
          return await productResponse.text();
        })
      );

      if (abortController.signal.aborted) return;

      productRecommendationBody.insertAdjacentHTML('beforeend', htmlChunks.join(''));
      const insertedProducts = productRecommendationBody.querySelectorAll('.rec-products');
      if (insertedProducts.length === 0) {
        recommendedSection.classList.add('d-none');
        return;
      }

      recommendedSection.classList.remove('d-none');

      const sectionId = productRecommendationBody.dataset.sectionid || recommendedSection.id;
      sliderRecommendedProducts(sectionId, productRecommendationBody);

      document.dispatchEvent(
        new CustomEvent('shopify-recommendation:init-product-grid', {
          detail: { recommendations: products },
        })
      );

      const imageRatio = recommendedSection.dataset.imageratio;
      if (imageRatio) {
        productRecommendationBody.querySelectorAll('img').forEach((image) => {
          image.classList.add(imageRatio);
        });
      }
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      recommendedSection.classList.add('d-none');
      // Keep some signal for debugging, but avoid noisy logging on successful loads.
      console.error(err);
    } finally {
      delete recommendedSection.dataset.recommendationsLoading;
    }
  }

  // recommended products slider
  function sliderRecommendedProducts(sectionId, productRecommendationBody) {
    if (typeof window.tns !== 'function') return;
    if (!sectionId) return;

    const escapedSectionId = cssEscape(sectionId);

    try {
      const slider = window.tns({
        container: productRecommendationBody,
        items: 1,
        slideBy: 1,
        nav: false,
        speed: 400,
        mode: 'carousel',
        prevButton: `#${escapedSectionId} .js-slider-sites-prev`,
        nextButton: `#${escapedSectionId} .js-slider-sites-next`,
        autoplayButtonOutput: false,
        autoplay: false,
        controls: true,
        freezable: true,
        touch: false,
        mouseDrag: false,
        preventScrollOnTouch: true,
        navPosition: 'bottom',
        rewind: true,
        lazyload: false,
        center: false,
        loop: false,
        controlsContainer: `#${escapedSectionId} .recommendations-slider-controls`,
        responsive: {
          480: { items: 1 },
          640: { items: 2 },
          768: { items: 3 },
        },
      });
      slider.refresh();
    } catch (err) {
      console.error(err);
    }
  }
})();
